module.exports = __webpack_public_path__ + "images/content-valuable.deef8a56d00e94f62d3fe4b3b1b70b83.svg";